/**
 * useSessionTypesLoader - 수업 유형을 전역 스토어로 로드 (단순캐시 / 옵션2)
 *
 * ISSUE_167: 실제 fetch·캐시·realtime 은 `core/query/useSessionTypes` 팩토리가 담당.
 * 이 훅은 미러를 전역 마운트(root.tsx)만 한다.
 * ISSUE_182: scratch 폐기 → "개인 워크스페이스 기본 타입 자동생성" 제거.
 *
 * @module useSessionTypesLoader
 */

import { useSessionTypesMirror } from "~/core/query/useSessionTypes";

/**
 * 수업 유형을 전역 스토어로 로드 (앱 초기화 시 1회 마운트).
 */
export function useSessionTypesLoader() {
  useSessionTypesMirror();
}

export default useSessionTypesLoader;
